import { ModalOpenButton } from "@msys/ui";
import { Edit as EditIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { namedOperations } from "../../../../clients/graphqlTypes.js";
import { CustomFieldsBox } from "../../custom-fields/CustomFieldsBox.js";
import { EditCustomFieldModal } from "../../custom-fields/EditCustomFieldModal.js";
import { CrmCompanyCustomFieldsBox_CrmCompanyFragment } from "./CrmCompanyCustomFieldsBox.generated.js";
import { RestrictedByOrganisationPermissionWithDebug } from "../../../auth/RestrictedByOrganisationPermission.js";

interface Props {
  crmCompany: CrmCompanyCustomFieldsBox_CrmCompanyFragment;
}

export const CrmCompanyCustomFieldsBox = ({ crmCompany }: Props) => {
  const { t } = useTranslate("OrganisationProfile");

  return (
    <CustomFieldsBox
      source={crmCompany}
      objectType={"Organisation"}
      actionButton={
        <RestrictedByOrganisationPermissionWithDebug permission="crm_record_update">
          <ModalOpenButton
            Modal={EditCustomFieldModal}
            modalProps={{
              title: t("Edit organisation custom fields"),
              objectId: crmCompany.id,
              objectType: "Organisation",
              customFields: crmCompany.customFields,
              refetchQueries: [namedOperations.Query.CrmCompanyProfile],
            }}
          >
            <IconButton color="secondary" size="small">
              <EditIcon />
            </IconButton>
          </ModalOpenButton>
        </RestrictedByOrganisationPermissionWithDebug>
      }
    />
  );
};
